import { useEffect, useState } from 'react';

import { marketingLinks } from 'utils/siteLinks';
import { COOKIE_SETTINGS_EVENT, getCookieChoice, setCookieChoice } from 'utils/cookieConsent';

import styles from './CookieConsent.module.scss';

export function CookieConsent() {
  const [open, setOpen] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setOpen(getCookieChoice() === null);
    setReady(true);
    const show = () => setOpen(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, show);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, show);
  }, []);

  const choose = (accepted: boolean) => {
    setCookieChoice(accepted);
    setOpen(false);
  };

  if (!ready || !open) return null;

  return (
    <div className={styles.wrap} role='dialog' aria-live='polite' aria-label='Файлы на устройстве'>
      <div className={styles.card}>
        <div className={styles.info}>
        <p className={styles.title}>Файлы на устройстве</p>
        <p className={styles.text}>
          Кабинет считает посещения на своих серверах: страницу, откуда пришли и тип устройства.
          Кнопка "Отклонить" выключает этот счет со следующей страницы. Яндекс Метрика, запись
          экрана и привязка к учетной записи включаются только после "Принять". Подробнее в{' '}
          <a
            href={marketingLinks.privacy}
            className={styles.link}
            target='_blank'
            rel='noopener noreferrer'
          >
            политике обработки персональных данных
          </a>
          .
        </p>
        </div>
        <div className={styles.actions}>
          <button
            type='button'
            className={`${styles.choiceBtn} ${styles.choiceBtnSecondary}`}
            onClick={() => choose(false)}
          >
            Отклонить
          </button>
          <button type='button' className={styles.choiceBtn} onClick={() => choose(true)}>
            Принять
          </button>
        </div>
      </div>
    </div>
  );
}
